import { ProductTypes } from '../main/constants/ProductTypes';

export interface IPeriod {
    from: string;
    to: string;
}
export interface IProductPayload {
    id: string;
    current_period: IPeriod;
    expires_at: string | null;
    quantity: number;
    used_credits: number;
    period: string | null;
    type: ProductTypes;
    created_at: string;
}
export interface IActiveProductPayload {
    id: string;
    currentPeriod: IPeriod;
    expiresAt: string | null;
    quantity: number;
    usedCredits: number;
    period: string | null;
    type: ProductTypes;
    createdAt: string;
}

export class ActiveProduct {
    private readonly _id: string;
    private readonly _currentPeriod: IPeriod;
    private readonly _expiresAt: string;
    private readonly _quantity: number;
    private readonly _usedCredits: number;
    private readonly _period: string;
    private readonly _type: ProductTypes;
    private readonly _createdAt: string;

    constructor(payload: IActiveProductPayload) {
        this._id = payload.id;
        this._currentPeriod = payload.currentPeriod;
        this._expiresAt = payload.expiresAt || '';
        this._quantity = payload.quantity;
        this._usedCredits = payload.usedCredits;
        this._period = payload.period || '';
        this._type = payload.type;
        this._createdAt = payload.createdAt;
    }

    get id(): string {
        return this._id;
    }

    get currentPeriod(): IPeriod {
        return this._currentPeriod;
    }

    get expiresAt(): string {
        return this._expiresAt;
    }

    get quantity(): number {
        return this._quantity;
    }

    get usedCredits(): number {
        return this._usedCredits;
    }

    get period(): string {
        return this._period;
    }

    get type(): ProductTypes {
        return this._type;
    }

    get createdAt(): string {
        return this._createdAt;
    }

    public getPayload(): IProductPayload {
        return {
            id: this.id,
            current_period: {
                from: this.currentPeriod.from,
                to: this.currentPeriod.to,
            },
            expires_at: this.expiresAt,
            quantity: this.quantity,
            used_credits: this.usedCredits,
            period: this.period,
            type: this.type,
            created_at: this.createdAt,
        };
    }
}
